import { apiFetch, getCoreApiBaseUrl } from "@justhome/api-runtime";
import { GatewayContext } from "./gatewayContext";

const pathPrefix = "";

const getBaseUrl = () => `${getCoreApiBaseUrl()}${pathPrefix}`;

export type ErrorWrapper<TError> =
  | TError
  | (Record<string, unknown> & {
      status: number;
    });

export type GatewayFetcherOptions<TBody, THeaders, TQueryParams, TPathParams> = {
  url: string;
  method: string;
  body?: TBody;
  headers?: THeaders;
  queryParams?: TQueryParams;
  pathParams?: TPathParams;
  signal?: AbortSignal;
} & GatewayContext["fetcherOptions"];

export async function gatewayFetch<
  TData,
  TError,
  TBody extends {} | FormData | undefined | null,
  THeaders extends {},
  TQueryParams extends {},
  TPathParams extends {},
>(
  options: GatewayFetcherOptions<TBody, THeaders, TQueryParams, TPathParams>,
): Promise<TData> {
  return apiFetch({
    ...options,
    name: "gateway",
    baseUrl: getBaseUrl(),
  });
}
